import { IconButton } from 'components';
import { reportTypes as reportTypesConst } from 'constants/report';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { getReportTypes } from 'services/report';
import { Label } from 'styles/Details';
import { Flex } from 'styles/Flex';
import { PageContent } from 'styles/PageContent';
import { ReportTypes } from 'types/report';
import { openNotification } from 'utils/notification';
import { ClosingReport } from './Reports';
import * as Styles from './styles';

type Props = RouteComponentProps;

export const ClosingPage = ({ history }: Props) => {
  const [tPage] = useTranslation('pages/report');
  const [reportTypes, setReportTypes] = useState<{ label: string; value: string }[]>([]);
  const [type] = useState<ReportTypes>(reportTypesConst.closing as ReportTypes);

  const renderReport = useMemo(() => {
    if (!type) return null;

    return {
      [reportTypesConst.closing]: <ClosingReport type={type} />,
    }[type];
  }, [type]);

  const handleGetReportTypes = useCallback(async () => {
    try {
      const { data } = await getReportTypes();

      const newOptions = data
        .filter(type => type === reportTypesConst.financial)
        .map(type => ({ label: tPage(`reportTypes.${type}`), value: type }));

      setReportTypes(newOptions);
    } catch (error) {
      openNotification(tPage('notGetReportTypesError'), 'error');
      console.log(error);
    }
  }, []);

  useEffect(() => {
    handleGetReportTypes();
  }, []);

  return (
    <Styles.Container>
      <Flex alignItems="center" gap={0.5} marginBottom={0.8}>
        <IconButton
          icon={{
            name: 'arrowBack',
            color: 'text',
            size: 1.5,
          }}
          onClick={history.goBack}
        />
        <h1>Fechamento Diário</h1>
      </Flex>

      <PageContent>
        <Flex marginBottom={0.8}>
          <Label>{tPage('reportData')}</Label>
        </Flex>

        {renderReport}
      </PageContent>
    </Styles.Container>
  );
};
